import apiClient, { apiFormClient } from "../utils/apiClient";

const getReportPagination = async (params) => {
    try {
        const response = await apiClient.get("/api/phan-anh", { params });
        if (response.data.success) {
            return response.data;
        } else {
            throw new Error(response.data.message || "Lấy danh sách phản ánh thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const getHistoryStatus = async (reportId) => {
    try {
        const response = await apiClient.get(`/api/phan-anh/${reportId}/lich-su-trang-thai`);
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy lịch sử trạng thái thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const getExtent = async () => {
    try {
        const response = await apiClient.get("/api/phan-anh/muc-do");
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy mức độ phản ánh thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const getStatusReport = async () => {
    try {
        const response = await apiClient.get("/api/phan-anh/trang-thai");
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy trạng thái phản ánh thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const getReportById = async (reportId) => {
    try {
        const response = await apiClient.get(`/api/phan-anh/${reportId}`);
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy phản ánh thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const updateStatusReport = async (reportId, statusData) => {
    try {
        const { files = [], idVideoGiaiQuyet = [], trangThai, ghiChu, ngayDuKienHoanThanh } = statusData || {};

        const formData = new FormData();
        if (trangThai !== undefined && trangThai !== null) {
            formData.append("trangThai", trangThai);
        }
        if (ghiChu !== undefined && ghiChu !== null) {
            formData.append("ghiChu", ghiChu);
        }
        if (ngayDuKienHoanThanh !== undefined && ngayDuKienHoanThanh !== null) {
            formData.append("ngayDuKienHoanThanh", ngayDuKienHoanThanh);
        }
        // Ảnh hiện trường: nhiều file cùng field "file" (khớp hợp đồng BE)
        files.forEach((file) => formData.append("file", file));
        // Video hiện trường đã xử lý: mảng id video_uploads đã upload HLS
        (idVideoGiaiQuyet || []).forEach((id) => formData.append("idVideoGiaiQuyet", id));

        const response = await apiFormClient.put(`/api/phan-anh/update-status/${reportId}`, formData);
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorData = {
                message: response.data.message || "Cập nhật trạng thái phản ánh thất bại",
                errors: response.data.errors || []
            };
            throw errorData;
        }
    } catch (error) {
        if (error.response?.data) {
            const errorData = {
                message: error.response.data.message || "Cập nhật trạng thái phản ánh thất bại",
                errors: error.response.data.errors || []
            };
            throw errorData;
        }
        throw error;
    }
}

const updateLinhVucReport = async (reportId, idLinhVucPhanAnh, lyDo) => {
    try {
        const response = await apiClient.put(
            `/api/phan-anh/update-linh-vuc/${reportId}`,
            { idLinhVucPhanAnh, lyDo }
        );
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorData = {
                message: response.data.message || "Cập nhật lĩnh vực phản ánh thất bại",
                errors: response.data.errors || []
            };
            throw errorData;
        }
    } catch (error) {
        if (error.response?.data) {
            const errorData = {
                message: error.response.data.message || "Cập nhật lĩnh vực phản ánh thất bại",
                errors: error.response.data.errors || []
            };
            throw errorData;
        }
        throw error;
    }
}

const updateMucDoReport = async (reportId, mucDo, lyDo) => {
    try {
        const response = await apiClient.put(
            `/api/phan-anh/update-muc-do/${reportId}`,
            { mucDo, lyDo }
        );
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorData = {
                message: response.data.message || "Cập nhật mức độ phản ánh thất bại",
                errors: response.data.errors || []
            };
            throw errorData;
        }
    } catch (error) {
        if (error.response?.data) {
            const errorData = {
                message: error.response.data.message || "Cập nhật mức độ phản ánh thất bại",
                errors: error.response.data.errors || []
            };
            throw errorData;
        }
        throw error;
    }
}

const getAssignableUsers = async (reportId) => {
    try {
        const response = await apiClient.get(`/api/phan-anh/${reportId}/nguoi-xu-ly`);
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy danh sách chuyên viên xử lý thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const assignReport = async (reportId, idNguoiXuLy, lyDo) => {
    try {
        const response = await apiClient.put(`/api/phan-anh/assign/${reportId}`, { idNguoiXuLy, lyDo });
        if (response.data.success) {
            return response.data.data;
        } else {
            const errorData = {
                message: response.data.message || "Phân công xử lý phản ánh thất bại",
                errors: response.data.errors || []
            };
            throw errorData;
        }
    } catch (error) {
        if (error.response?.data) {
            const errorData = {
                message: error.response.data.message || "Phân công xử lý phản ánh thất bại",
                errors: error.response.data.errors || []
            };
            throw errorData;
        }
        throw error;
    }
}

const getStatisticReport = async (params) => {
    try {
        const response = await apiClient.get("/api/phan-anh/tong-quan", { params });
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy thống kê phản ánh thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const getPhanAnhTheoThang = async ({ from, to, idLinhVuc } = {}) => {
    try {
        const params = {};
        if (from) params.from = from;
        if (to) params.to = to;
        if (idLinhVuc) params.id_linh_vuc = idLinhVuc;

        const response = await apiClient.get("/api/report/phan-anh/theo-thang", { params });
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy báo cáo phản ánh theo tháng thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
}

const createReport = async (reportData) => {
    try {
        const { files = [], ...fields } = reportData || {};
        const formData = new FormData();

        // Append all text fields
        Object.keys(fields).forEach((key) => {
            if (fields[key] !== undefined && fields[key] !== null) {
                if (Array.isArray(fields[key])) {
                    fields[key].forEach(val => formData.append(key, val));
                } else {
                    formData.append(key, fields[key]);
                }
            }
        });

        // Append files
        files.forEach((file) => formData.append("file", file));

        const response = await apiFormClient.post("/api/phan-anh", formData);

        if (response.data.success) {
            return response.data.data;
        } else {
            const errorData = {
                message: response.data.message || "Tạo phản ánh thất bại",
                errors: response.data.errors || []
            };
            throw errorData;
        }
    } catch (error) {
        if (error.response?.data) {
            const errorData = {
                message: error.response.data.message || "Tạo phản ánh thất bại",
                errors: error.response.data.errors || []
            };
            throw errorData;
        }
        throw error;
    }
}

const getExtensions = async (params) => {
    try {
        const response = await apiClient.get("/api/phan-anh/extension", { params });
        if (response.data.success) {
            return response.data;
        } else {
            throw new Error(response.data.message || "Lấy danh sách đề nghị gia hạn thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const getExtensionStats = async (params) => {
    try {
        const response = await apiClient.get("/api/phan-anh/extension/stats", { params });
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy thống kê đề nghị gia hạn thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const getExtensionById = async (id) => {
    try {
        const response = await apiClient.get(`/api/phan-anh/extension/${id}`);
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Lấy chi tiết đề nghị gia hạn thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const createExtension = async ({ complaintId, requestedDeadline, reason, files = [] }) => {
    try {
        const formData = new FormData();
        formData.append("complaintId", complaintId);
        formData.append("requestedDeadline", requestedDeadline);
        formData.append("reason", reason);
        (files || []).forEach((f) => formData.append("file", f));

        const response = await apiFormClient.post("/api/phan-anh/extension/request", formData);
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Tạo đề nghị gia hạn thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const approveExtension = async (id, ghiChu) => {
    try {
        const response = await apiClient.put(`/api/phan-anh/extension/${id}/approve`, { ghiChu });
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Phê duyệt gia hạn thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const rejectExtension = async (id, lyDoTuChoi) => {
    try {
        const response = await apiClient.put(`/api/phan-anh/extension/${id}/reject`, { lyDoTuChoi });
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message || "Từ chối gia hạn thất bại");
        }
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const exportReportExcel = async (params = {}) => {
    try {
        const response = await apiClient.post('/api/phan-anh/export-excel', params, {
            responseType: 'blob',
        });
        return { success: true, data: response.data };
    } catch (error) {
        let message = 'Xuất file Excel thất bại';
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                if (json.message) message = json.message;
            } catch { }
        } else if (error.response?.data?.message) {
            message = error.response.data.message;
        }
        return { success: false, error: message };
    }
};

const exportExtensionExcel = async (params = {}) => {
    try {
        const response = await apiClient.get('/api/phan-anh/extension/export-excel', {
            params,
            responseType: 'blob',
        });
        return { success: true, data: response.data };
    } catch (error) {
        let message = 'Xuất file Excel gia hạn thất bại';
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                if (json.message) message = json.message;
            } catch { }
        } else if (error.response?.data?.message) {
            message = error.response.data.message;
        }
        return { success: false, error: message };
    }
};

export const REPORT_API = {
    getReportPagination,
    getHistoryStatus,
    getExtent,
    getStatusReport,
    getReportById,
    updateStatusReport,
    updateLinhVucReport,
    updateMucDoReport,
    getAssignableUsers,
    assignReport,
    getStatisticReport,
    getPhanAnhTheoThang,
    createReport,
    getExtensions,
    getExtensionStats,
    getExtensionById,
    createExtension,
    approveExtension,
    rejectExtension,
    exportReportExcel,
    exportExtensionExcel,
};